import { IQueryMetaDataType } from "../../../../../boilerplate/redux/types/IQueryMetaDataType";
import { IApiErrorType } from "../../../../types/BaseTypes";

/* ### CONSTANTS ### */
export const CONFIRM_LOTTERY_REGISTRATION_FETCH_ENTRIES = '@BasePipeline/confirmLotteryRegistrationReducer_FETCH_ENTRIES';
export const CONFIRM_LOTTERY_REGISTRATION_ADD_ENTRIES = '@BasePipeline/confirmLotteryRegistrationReducer_ADD_ENTRIES';
export const CONFIRM_LOTTERY_REGISTRATION_ADD_ENTRY = '@BasePipeline/confirmLotteryRegistrationReducer_ADD_ENTRY';

export const CONFIRM_LOTTERY_REGISTRATION_SET_ERRORS   = '@BasePipeline/confirmLotteryRegistrationReducer_SET_ERRORS';

/* ### ACTIONS ### */

export function addConfirmLotteryRegistrationEntries (queryKey: string, entries: [], metaData?: IQueryMetaDataType , options?: IFetchOptionType) {
	return {
		type: CONFIRM_LOTTERY_REGISTRATION_ADD_ENTRIES,
		queryKey,
		entries,
		metaData,
		options
	};
}

export function setConfirmLotteryRegistrationErrors (queryKey: string, errors: IApiErrorType[], metaData?: IQueryMetaDataType , options?: IFetchOptionType) {
	return {
		type: CONFIRM_LOTTERY_REGISTRATION_SET_ERRORS,
		queryKey,
		errors,
		metaData,
	};
}
